import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import AuthActions from '@/actions/Auth'
import NoticeActions from '@/actions/Notice'
import { getLanguage, localStrings } from '@/utils/localization'
import NavbarConsoleComponent from '@/components/Console/Navbar'
import { instanceOf } from 'prop-types'
import { withCookies, Cookies } from 'react-cookie'
import {
  getProductFromSessionStorage,
  setProductToSessionStorage,
  getUserInfoFromLocalStorage
} from '@/utils/auth'
import ServiceActions from '@/actions/Service'
import PayActions from '@/actions/Pay'

@inject('store')
@observer
class NavbarConsoleContainer extends Component {
  commonStore = this.props.store.commonStore

  state = {
    toggleContactOn: false,
    toggleAlarmOn: false,
    toggleUserMenuOn: false,
    noticeText: '',
    noticeCookie: '',
    path: '',
    product: getProductFromSessionStorage()
      ? getProductFromSessionStorage()
      : 'WRAPSODY',
    isRenew: false
  }

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  }

  constructor(props) {
    super(props)
    let path = window.location.pathname.split('/')
    let params = new URL(document.location).searchParams

    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    const { cookies } = props

    this.state = {
      ...this.state,
      path: path[path.length - 1],
      noticeCookie: cookies.get('closeTodayNotice')
    }

    this.commonStore.setClose30dGuide(
      cookies.get('close30dGuide') === 'YES' ? true : false
    )
  }

  async closeNoticeToday() {
    const { cookies } = this.props
    const timestamp = new Date().getTime()
    const expire = timestamp + 1000 * 60 * 60 * 24
    const expireDate = new Date(expire)
    cookies.set('closeTodayNotice', 'YES', { path: '/', expires: expireDate })
    this.setState({
      ...this.state,
      noticeCookie: cookies.get('closeTodayNotice'),
      noticeText: ''
    })
  }

  async closeNotice() {
    this.setState({
      ...this.state,
      noticeText: ''
    })
  }

  async checkProductAvailable(product) {
    const checkCashStatus = await ServiceActions.checkUserCashStatus({
      product: [product]
    })
    if (
      (checkCashStatus && checkCashStatus.status === 'WAIT') ||
      (checkCashStatus.serviceUid === '' &&
        checkCashStatus.status === 'APPLY') ||
      checkCashStatus.status === 'APPROVED'
    ) {
      return true
    } else {
      const serviceList = await ServiceActions.getMyServiceList(product)
      if (serviceList === null) {
        try {
          const unregisterPay = await PayActions.getServiceUnregisterBill(
            'PAY',
            product
          )
          const unregisterPromotion = await PayActions.getServiceUnregisterBill(
            'PROMOTION',
            product
          )
          if (unregisterPay.length > 0) return true
          else if (unregisterPromotion.length > 0) return true
          else {
            let result = await PayActions.applyCheckPromotionCode(product)
            if (result) {
              return true
            } else {
              result = await PayActions.checkPromotionTrial(product)
              return result.status === 'IMPOSSIBLE' ||
                result.status === 'POSSIBLE' ||
                result.status === 'EXIST' ||
                result.status === 'T_USED'
                ? false
                : true
            }
          }
        } catch (err) {
          return false
        }
      }
    }
    return true
  }
  async componentWillMount() {
    try {
      const cloudNoticeInfoOne = await NoticeActions.getOne()

      const { noticeCookie } = this.state

      let querystring = window.location.search.substr(1).split('?')
      let params
      let isRenew = false
      let newProduct = 'WRAPSODY'
      if (querystring !== '') {
        params = new URLSearchParams(querystring[0])
      }
      if (params.has('type') && params.get('type') === 'renew') {
        isRenew = true
      }
      let noticeText = ''
      if (getUserInfoFromLocalStorage()) {
        if (
          params.has('product') &&
          (params.get('product') === 'WRAPSODY' ||
            params.get('product') === 'WRAPSODY_ECO')
        ) {
          newProduct = params.get('product')
          setProductToSessionStorage(newProduct)
          this.setState({
            path: 'console',
            product: newProduct
          })
        } else if (getProductFromSessionStorage()) {
          this.setState({
            //  path: 'console',
            product: getProductFromSessionStorage()
          })
        } else if (!getProductFromSessionStorage()) {
          let wrapsodyActive = await this.checkProductAvailable('WRAPSODY')
          let ecoActive = await this.checkProductAvailable('WRAPSODY_ECO')
          newProduct =
            !wrapsodyActive && ecoActive ? 'WRAPSODY_ECO' : 'WRAPSODY'
          const lang = getLanguage()
          setProductToSessionStorage(newProduct)
          this.setState({
            path: 'console',
            product: newProduct
          })
          if (wrapsodyActive || ecoActive) {
            window.location.href = `${process.env.PUBLIC_URL}/${lang}/console`
          } else {
            window.location.href = `${process.env.PUBLIC_URL}/${lang}/site/type`
          }
        }
      }

      if (
        cloudNoticeInfoOne !== null &&
        cloudNoticeInfoOne.length > 0 &&
        noticeCookie !== 'YES'
      ) {
        if (localStrings.getLanguage() === 'ko') {
          noticeText = cloudNoticeInfoOne[0].noticeKo
        } else {
          noticeText = cloudNoticeInfoOne[0].noticeEn
        }
      }
      this.setState({
        //...this.state,
        noticeText,
        isRenew
      })
    } catch (error) {
      console.log(error)
    }
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  setWrapperRef(node) {
    this.wrapperRef = node
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        ...this.state,
        toggleContactOn: false,
        toggleAlarmOn: false,
        toggleUserMenuOn: false
      })
    }
  }

  async logout() {
    const lang = getLanguage()
    try {
      await AuthActions.logout()
      window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
    } catch (error) {
      if (error.errorCode && error.errorMessage) {
        alert(error.errorMessage)
      }
    }
  }

  goConsole() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/console`
  }

  goBill() {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/bill`
  }

  async toggleContact() {
    this.setState({
      ...this.state,
      toggleContactOn: !this.state.toggleContactOn,
      toggleAlarmOn: false,
      toggleUserMenuOn: false
    })
  }

  async toggleAlarm() {
    this.setState({
      ...this.state,
      toggleContactOn: false,
      toggleAlarmOn: !this.state.toggleAlarmOn,
      toggleUserMenuOn: false
    })
  }

  async toggleUserMenu() {
    this.setState({
      ...this.state,
      toggleContactOn: false,
      toggleAlarmOn: false,
      toggleUserMenuOn: !this.state.toggleUserMenuOn
    })
  }
  handleChangeForDropdown(name, value) {
    const state = { ...this.state }
    const lang = getLanguage()
    state[name] = value
    setProductToSessionStorage(value)
    this.setState(state)
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/console`
  }

  render() {
    const {
      path,
      toggleContactOn,
      toggleAlarmOn,
      toggleUserMenuOn,
      noticeText,
      product,
      isRenew
    } = this.state

    return (
      <NavbarConsoleComponent
        path={path}
        product={product}
        noticeText={noticeText}
        logout={this.logout.bind(this)}
        goConsole={this.goConsole}
        goBill={this.goBill}
        toggleContact={this.toggleContact.bind(this)}
        toggleContactOn={toggleContactOn}
        toggleAlarm={this.toggleAlarm.bind(this)}
        toggleAlarmOn={toggleAlarmOn}
        toggleUserMenu={this.toggleUserMenu.bind(this)}
        toggleUserMenuOn={toggleUserMenuOn}
        setWrapperRef={this.setWrapperRef.bind(this)}
        closeNoticeToday={this.closeNoticeToday.bind(this)}
        closeNotice={this.closeNotice.bind(this)}
        handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
        isRenew={isRenew}
      />
    )
  }
}

export default withCookies(NavbarConsoleContainer)



// WEBPACK FOOTER //
// ./src/containers/Console/Navbar/index.js